const parseMarkup = (block: string) => {
  // Regular expression to match underscores (_) not surrounded by word characters (\w)

  // doesn't work on old browsers (lookbehind support)
  //const regex = /(?<!\w)(_|[*]{3})([^_]+)\1(?!\w)/g;

  const regex = /^(?!\w)(_|[*]{3})([^_]+)\1(?!\w)/g
  // Replace underscores with italic formatting
  block = block.replace(regex, "<i>$2</i>")

  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g
  block = block.replace(linkRegex, '<a href="$2">$1</a>')

  const strongRegex = /(\*\*|__)(.*?)\1/g
  return block.replace(strongRegex, "<strong>$2</strong>")
}

export const parseMarkdown = (markdown: string): string => {
  let output = ""
  const blocks = markdown
    .replace(/\n\s*\n/g, "\n\n")
    .replace(/(#.*?\n)/g, "$1\n")
    .split("\n\n")
  blocks.forEach((block) => {
    block = block.replace(/^\n+|\n+$/g, "")

    // doesn't work on old browsers (lookbehind support)
    //block = block.replace(/(?<!\n)\n(?!\n)/g, "<br>")

    block = block.replace(/^(?!\n)\n(?!\n)/g, "<br>")
    output += parseBlock(block)
  })

  return output
}

const parseBlock = (block: string): string => {
  if (block.trim().startsWith("#")) {
    return parseHeader(block)
  } else if (block.trim().startsWith("- ") || block.trim().startsWith("* ")) {
    return parseList(block)
  } else if (block.trim().startsWith("---") || block.trim().startsWith("***")) {
    return "<hr>"
  } else {
    return parseParagraph(block)
  }
}

const parseHeader = (block: string): string => {
  let level = 0
  while (block[level] === "#") {
    level++
  }
  const headerText = parseMarkup(block.substring(level).trim())
  return `<h${level}>${headerText}</h${level}>`
}

const parseList = (block: string): string => {
  const lines = block.split("\n")
  let output = "<ul>"
  lines.forEach((line) => {
    const listItemContent = parseMarkup(line.substring(2).trim()) // Parse markup inside the list item
    output += `<li>${listItemContent}</li>`
  })
  output += "</ul>"
  return output
}

const parseParagraph = (block: string): string => {
  block = parseMarkup(block)

  const lines = block.split("\n")
  let output = "<p>"
  lines.forEach((line, index) => {
    output += `${line.replace(/(\*|_)(.*?)\1/g, "<em>$2</em>")}`
    if (index !== lines.length - 1) {
      output += "<br>"
    }
  })
  output += "</p>"
  return output
}
